import React, { memo } from "react"
import { FormattedMessage } from "react-intl"

type Props = {
  label: string | "" | undefined
  values?: {} | undefined
}

export type TranslationType = Props

function Translation({ label, values }: Props) {
  return label ? <FormattedMessage id={label.toLowerCase()} values={values} defaultMessage={label} /> : null
}

export default memo(Translation)
